import IconInsightsGoogle from 'assets/insights/icon-insights-google.svg';
import IconInsightsEmail from 'assets/insights/icon-insights-email.svg';
import IconInsightsDiscount from 'assets/insights/icon-insights-discount.svg';
import IconInsightsMenu from 'assets/insights/icon-insights-menu.svg';
import IconInsightsSocial from 'assets/insights/icon-insights-social.svg';
import IconInsightsManagePrices from 'assets/insights/icon-insights-manage-prices.svg';
import IconInsightsFreeDelivery from 'assets/insights/icon-insights-free-delivery.svg';
import IconInsightsVA from 'assets/insights/icon-insights-va.svg';
import IconInsightsCatering from 'assets/insights/icon-insights-catering.svg';
import IconInsightsWebsiteOptimization from 'assets/insights/icon-insights-website-optimization.svg';
import IconInsightsItemDescription from 'assets/insights/icon-insights-item-description.svg';
import IconInsightsGooglePreferred from 'assets/insights/icon-insights-google-preferred.svg';

export const INSIGHTS_GROWTH_FEATURES_INFO = {
  websiteOptimization: {
    name: 'Website Optimization',
    description:
      'Is your website optimized for mobile with a single ordering link?',
    motivation:
      'Optimizing customer experience for mobile can boost orders x2!',
    icon: IconInsightsWebsiteOptimization,
    nameForRequest: 'website-optimization',
    learMore:
      'https://support.getsauce.com/optimizing-your-website-for-more-orders?hs_preview=qgPojliQ-164438229527',
    section: 'digitalOptimization'
  },

  googleMarketing: {
    name: 'Google Optimization',
    description: "Don't let 3rd parties hijack your customers!",
    motivation:
      'Removing other links from your Google listing can boost orders by over 30%',
    learMore:
      'https://support.getsauce.com/edit-your-google-my-business-website',
    icon: IconInsightsGoogle,
    nameForRequest: 'google-marketing',
    disableInsightControlModule: true,
    section: 'digitalOptimization'
  },
  googlePreferred: {
    name: 'Google Preferred',
    description: 'Click “Preferred” next to Sauce in Google ordering',
    motivation:
      'Boost direct sales by displaying Sauce as your preferred ordering option',
    learMore: 'https://support.getsauce.com/google-business-preferred',
    icon: IconInsightsGooglePreferred,
    nameForRequest: 'google-preferred',
    disableInsightControlModule: true,
    section: 'digitalOptimization'
  },
  virtualAnswering: {
    name: 'Virtual Answering',
    description: 'Save time & reduce workloads. We’ll look after the phone!',
    motivation:
      'Virtual answering saves on labor and converts into direct orders by up to 28%',
    learMore: 'https://support.getsauce.com/introducing-virtual-number',
    icon: IconInsightsVA,
    nameForRequest: 'virtual-answering',
    disableInsightControlModule: true,
    section: 'digitalOptimization'
  },

  menuPhotos: {
    name: 'Menu Photos',
    description: 'Are you making the most of photos on your online menu?',
    motivation:
      'Good photography can increase order volume and item count by over 21%',
    learMore: 'https://support.getsauce.com/menu-photography',
    icon: IconInsightsMenu,
    disableInsightControlModule: true,
    section: 'menuOptimization'
  },

  menuDescriptions: {
    name: 'Item Description',
    description: 'Descriptions make dishes stand out and are crucial for SEO',
    motivation:
      'Highlighting the unique flavors of dishes will bring big rewards for both your SEO and your bottom line!',
    learMore:
      'https://support.getsauce.com/the-importance-of-adding-item-descriptions-to-your-menu',
    icon: IconInsightsItemDescription,
    disableInsightControlModule: true,
    section: 'menuOptimization'
  },

  freeDelivery: {
    name: 'Free Delivery',
    description: 'Beat the competition with a free delivery offer',
    motivation:
      'FREE DELIVERY can convert customers to your direct menu by up to 26%!',
    learMore: 'https://support.getsauce.com/free-delivery',
    icon: IconInsightsFreeDelivery,
    disableInsightControlModule: true,
    section: 'pricingAndOffers'
  },
  discounts: {
    name: 'Discounts',
    description: 'Encourage your loyal customers to order every day!',
    motivation:
      '“Money off” discounts will create a sense of urgency for your customers',
    learMore: 'https://support.getsauce.com/discounts',
    icon: IconInsightsDiscount,
    disableInsightControlModule: true,
    section: 'pricingAndOffers'
  },
  managePrices: {
    name: 'Manage Prices',
    description: 'Create a cheaper, better offer  for your direct customers!',
    motivation:
      'Better menu pricing can convert up to 40% of your 3PD customers',
    learMore: 'https://support.getsauce.com/manage-prices',
    icon: IconInsightsManagePrices,
    disableInsightControlModule: true,
    section: 'pricingAndOffers'
  },
  socialMedia: {
    name: 'Social Media',
    description: 'Turn your social media into a revenue making machine!',
    motivation:
      'The right promotion can increase your website visits by over 150%',
    learMore: 'https://support.getsauce.com/social-media',
    icon: IconInsightsSocial,
    section: 'marketing'
  },
  emailMarketing: {
    name: 'Email Marketing',
    description:
      'Create a channel for your loyal customers to keep coming back',
    motivation:
      'Customer engagement is known to boost revenues by as much as 40%',
    learMore: 'https://support.getsauce.com/Email-Marketing',
    icon: IconInsightsEmail,
    nameForRequest: 'email-marketing',
    disableInsightControlModule: true,
    section: 'marketing'
  },
  catering: {
    name: 'Catering',
    description: 'Build a new revenue channel for your business',
    motivation:
      'Catering orders are, on average, 3X bigger than regular orders',
    icon: IconInsightsCatering,
    nameForRequest: 'catering',
    disableInsightControlModule: true,
    section: 'digitalOptimization'
  },
  byoc: {
    name: 'Sauce Self Delivery',
    description:
      'Reduce third-party delivery costs, simplify operations, and keep more revenue.',
    nameForRequest: 'byoc',
    disableInsightControlModule: true,
    section: 'digitalOptimization'
  }
};

export const INSIGHTS_GROWTH_SECTIONS = {
  DIGITAL_OPTIMIZATION: 'digitalOptimization',
  MENU_OPTIMIZATION: 'menuOptimization',
  PRICING_AND_OFFERS: 'pricingAndOffers',
  MARKETING: 'marketing'
};
export const INSIGHTS_GROWTH_SECTION_NAMES = {
  DIGITAL_OPTIMIZATION: 'Digital Optimization',
  MENU_OPTIMIZATION: 'Menu Optimization',
  PRICING_AND_OFFERS: 'Pricing & Offers',
  MARKETING: 'Marketing'
};
